module.exports = __webpack_public_path__ + "u.no2.b0c3fe0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/u.no2.jpg
// module id = SXLx
// module chunks = 0